module.exports = __webpack_public_path__ + "img/calendar.55b9c8ff.svg";